import * as React from 'react'

import { styled } from '~/styled'

import { Heading } from '../../heading/Heading'
import { useBannerContext } from '../BannerContext'

const StyledHeading = styled(
  Heading,
  {
    base: ['mb-4', 'text-(--banner-heading-color)'],
    variants: {
      containerSize: {
        sm: [],
        md: []
      },
      hasDismiss: {
        true: []
      }
    },
    compoundVariants: [
      {
        containerSize: 'sm',
        hasDismiss: true,
        class: ['mr-10']
      }
    ]
  },
  {
    enabledResponsiveVariants: true
  }
)

export const BannerRegularHeading = (
  props: React.ComponentPropsWithoutRef<typeof Heading>
) => {
  const { size, hasDismiss } = useBannerContext()

  return (
    <StyledHeading
      size="md"
      containerSize={size}
      hasDismiss={hasDismiss}
      {...props}
    />
  )
}

BannerRegularHeading.displayName = 'BannerRegularHeading'
